import { HYDRATE } from 'next-redux-wrapper';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  countries: [],
  currentLanguage: null,
  userInfo: null,
};

export const resourceSlice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    setCountries(state, action) {
      state.countries = action.payload;
    },
    setCurrentLanguage(state, action) {
      state.currentLanguage = action.payload;
    },
    setUserInfo(state, action) {
      state.userInfo = action.payload;
    },

    extraReducers: {
      [HYDRATE]: (state, action) => {
        return {
          ...state,
          ...action.payload.resource,
        };
      },
    },
  },
});

export const { setCountries, setCurrentLanguage, setUserInfo } = resourceSlice.actions;
export const selectCountries = (state) => state.resource.countries;
export const selectCurrentLanguage = (state) => state.resource.currentLanguage;
export const selectUserInfo = (state) => state.resource.userInfo;
export default resourceSlice.reducer;
